import { Registry } from './../registry/registry';
import { Injectable, EventEmitter } from '@angular/core';
import { Intercom } from 'ng-intercom';
import { User } from '../user/auth.service';
@Injectable()
export class AnalyticsService {

  constructor(

    private intercom: Intercom) {

  }

  isProd(): boolean {
    // return true;
    return window.location.hostname.endsWith('hitchd.com');
  }

  skipEuMarketing(): boolean {
    const iseu = localStorage.getItem('is_eu');
    let skipIntercom = false;
    if (iseu === 'true') {
      (<any>window).Metomic('getConsentState', { slug: 'marketing' }, ({ enabled }) => {
        skipIntercom = !enabled;
      });

    }
    return skipIntercom;
  }

  isEu() {
    const iseu = localStorage.getItem('is_eu');
    return iseu === 'true';
  }
  update(data: any) {




    const isSame = JSON.stringify(data) === (<any>window).idDataUser;
    if (!isSame) {

      (<any>window).idDataUser = JSON.stringify(data);
      //console.log('update user');
      (<any>window).analytics.identify((data));
    } else {
      // console.log('match duplicate call')
    }
  }

  identifyById(userId: string, data: any) {
    // console.log('identifyById');
    (<any>window).analytics.identify(userId, data);
  }
  identifyAnonymousUser( data: any) {

    const isSame = JSON.stringify(data) === (<any>window).identifyUser;
    if (!isSame) {
      (<any>window).identifyUser = JSON.stringify(data);
      // console.log('identify');
      (<any>window).analytics.identify( data);
    } else {
      // console.log('match duplicate call')
    }


  }

  setAnonymousId(email){
    if ((<any>window).analytics && (<any>window).analytics.user) {
     let anonymousId =  Buffer.from(email).toString('base64');
     (<any>window).analytics.user().anonymousId(anonymousId);
    }
  }

  identify(user: User, data: any) {



    const isSame = JSON.stringify(data) === (<any>window).identifyUser;
    if (!isSame) {
      (<any>window).identifyUser = JSON.stringify(data);
      // console.log('identify');
      (<any>window).analytics.identify(user.uid, data);
    } else {
      // console.log('match duplicate call')
    }

  }
  identifySegmentUser(user: User) {
    // console.log('identifySegmentUser');
    (<any>window).analytics.identify(user.uid, {
      email: user.email,
      emailVerified: user.emailVerified
    });
  }
  identifySegmentUserWithRegData(user: User
    , registry: Registry
    , weddingDate: Date
    , totalGiftsRemaining: number
    , totalGiftsSold: number
    , totalRegistryValue: number
    , totalGiftsCreated: number
  ) {



    const data = {
      email: user.email,
      emailVerified: user.emailVerified,
      currency: registry.currency,
      country: registry.country,
      feeMode: registry.feeMode,
      registryName: 'hitchd.com/' + registry.registryName,
      totalGiftsRemaining: totalGiftsRemaining,
      totalGiftsSold: totalGiftsSold,
      totalRegistryValue: totalRegistryValue,
      totalGiftsCreated: totalGiftsCreated,
      backgroundHeaderImageUrl: registry.backgroundHeaderImageUrl,
      firstName: registry.firstName,
      partnerFirstName: registry.partnerFirstName,
      hasPassword: registry.hasPassword,
      isLive: registry.isLive,
      guestFeePercent: registry.guestFeePercent,
      coupleFeePercent: registry.coupleFeePercent,
      hashtag: registry.hashtag,
      profileImageUrl: registry.profileImageUrl,
      usedGiftAssistant: registry.usedGiftAssistant,
    };

    const isSame = JSON.stringify(data) === (<any>window).idData;
    if (!isSame) {
      (<any>window).idData = JSON.stringify(data);
      (<any>window).analytics.identify(user.uid, data);
// {Facebook Pixel: ƒ, FullStory: ƒ, Intercom: ƒ, Google Analytics: ƒ, Pinterest Tag: ƒ, …}
     
    } else {
      // console.log('match duplicate call')
    }

  }

  getAnonymousId() {

    if ((<any>window).analytics && (<any>window).analytics.user) {
      return (<any>window).analytics.user().anonymousId()
    }
    else { return null }


  }
  heap(event: any) {
    try {
      (<any>window).heap.track(event);
    } catch (ex) {
      console.log(ex);
    }
  }
  trackEvent(eventName: string, data: any) {
    (<any>window).analytics.track(eventName, data);
  }

  trackGoogleAdsAndPinterestEvent(eventName: string, data: any) {
    (<any>window).analytics.track(eventName, data, {
      integrations: {
        All: false,
        'Google AdWords New': true,
        'Segment.io': true,
        'Pinterest Tag': true,
        'ShareASale': true
      }
    });
  }

  identifySegmentUserIdWithData(userId: string, data: any) {

      (<any>window).analytics.identify(userId, data);
    
  }
}



// WEBPACK FOOTER //
// ./src/app/analytics/analytics.service.ts